import { AHText, Box, Input } from "arkh";
import React, { useState } from "react";
import { UserLoggedInNavigatorScreenProps } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { FormattedMessage } from "react-intl";
import { Lottie } from "../../components/Lottie";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { useNavigationHeader } from "@/src/common/navigationHeaderOptions";
import { withWebModalStack } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModalStack";
import { useMutation, graphql } from "react-relay";
import { StorecastCreateMutation } from "./__generated__/StorecastCreateMutation.graphql";

export const StorecastCreate = withWebModalStack(StorecastCreateC, true, {});

function StorecastCreateC(
  props: UserLoggedInNavigatorScreenProps<"StorecastCreate">
) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => <InnerStorecastCreate {...props} fetchKey={fetchKey} />}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerStorecastCreate(
  props: UserLoggedInNavigatorScreenProps<"StorecastCreate"> & {
    fetchKey: string;
  }
) {
  const [name, setName] = useState("");
  const [mutation, pending] = useMutation<StorecastCreateMutation>(graphql`
    mutation StorecastCreateMutation($name: String!, $assignScreenId: ID) {
      createDashboard(input: { name: $name, assignScreenId: $assignScreenId }) {
        dashboard {
          id
        }
      }
    }
  `);
  useNavigationHeader({
    type: "CREATE",
    disabled: name === "",
    onCancel() {
      props.navigation.goBack();
    },
    onSave() {
      mutation({
        variables: {
          name,
          assignScreenId: props.route.params.assignScreenId,
        },
        onCompleted: (data) => {
          props.navigation.pop(2);
          props.navigation.navigate("Dashboard", {
            dashboardId: data.createDashboard.dashboard.id,
          });
          props.navigation.navigate("WidgetAdd", {
            defaultTeams: [],
            position: {
              active: true,
              c: 0,
              h: 4,
              w: 2,
              x: 0,
              y: 0,
            },
            storecastId: data.createDashboard.dashboard.id,
          });
        },
      });
    },
    saveLoading: pending,
    defaultContentStyle: true,
  });

  const intl_tokens = useIntlTokens();
  return (
    <Box style={{ flex: 1 }} space="large">
      <AHText
        type="title-big"
        style={{ alignSelf: "center" }}
        spaceBottom="large"
      >
        <FormattedMessage
          description="StorecastCreateSetName title"
          defaultMessage="Name dashboard"
        />
      </AHText>
      <Input
        autoFocus
        placeholder={intl_tokens.Name}
        value={name}
        onChangeText={setName}
      />
      <Box
        style={{ flex: 1, alignContent: "center", justifyContent: "center" }}
      >
        <Lottie
          autoPlay
          loop
          source={require("./dashboard.json")}
          autoSize
          style={{
            alignSelf: "center",
            maxWidth: "50%",
          }}
        />
      </Box>
    </Box>
  );
}
